import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "search_press",
  "use": "search_press-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"search_press\"><path d=\"m15.53 14.47-2.79-2.79A5.98 5.98 0 0 0 14 8c0-3.31-2.69-6-6-6S2 4.69 2 8s2.69 6 6 6c1.39 0 2.66-.47 3.68-1.26l2.79 2.79c.15.15.34.22.53.22s.38-.07.53-.22c.29-.29.29-.77 0-1.06M8 6c-1.1 0-2 .9-2 2H5c0-1.66 1.34-3 3-3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol